const normalizeKey = (key = "") => String(key).replace(/[_\s-]/g, "").toLowerCase();

export const getValueByKey = (item, ...keys) => {
  if (!item || typeof item !== "object") return "";

  for (const key of keys.flat().filter(Boolean)) {
    if (Object.prototype.hasOwnProperty.call(item, key)) return item[key];

    const target = normalizeKey(key);
    const foundKey = Object.keys(item).find((itemKey) => normalizeKey(itemKey) === target);
    if (foundKey) return item[foundKey];
  }

  return "";
};

export const normalizeArrayData = (source) => {
  if (!source) return [];

  const parsed = typeof source === "string" ? JSON.parse(source) : source;
  if (Array.isArray(parsed)) return parsed;

  const candidates = [
    parsed?.data?.result?.data,
    parsed?.data?.result?.list,
    parsed?.data?.result,
    parsed?.result?.data,
    parsed?.result?.list,
    parsed?.result,
    parsed?.data?.data,
    parsed?.data?.list,
    parsed?.data,
    parsed?.LIST,
    parsed?.list,
    parsed?.rows,
    parsed?.items,
  ];

  return candidates.find(Array.isArray) || [];
};

export const normalizeProjectUserData = (source) => {
  return normalizeArrayData(source)
    .map((item) => {
      const projectId = getValueByKey(item, "PROJECT_ID");
      const projectName = getValueByKey(item, "PROJECT_NAME");
      const description = getValueByKey(item, "DESCRIPTION", "PROJECT_DESCRIPTION");
      const leaderName = getValueByKey(item, "LEADER_NM", "PROJECT_LEADER");

      return {
        ...item,
        PROJECT_ID: projectId,
        PROJECT_NAME: projectName,
        DESCRIPTION: description,
        PROJECT_DESCRIPTION: description,
        LEADER_ID: getValueByKey(item, "LEADER_ID"),
        LEADER_NM: leaderName,
        PROJECT_LEADER: leaderName,
      };
    })
    .filter((item) => item.PROJECT_ID || item.PROJECT_NAME);
};
